import dayjs from "dayjs";
import { OrderChangeRow, SaleOrderEditChange, SaleOrderEditEvent } from "../../../data/entities";

export const changeLabel = (change: SaleOrderEditChange) => change.field === "status" ? "Mở lại đơn hàng" : change.field === "due_date"
    ? "Ngày đến hạn"
    : `${change.item_code || change.item_name || "Sản phẩm/vật tư không xác định"} · Số lượng`;

export const changeValue = (field: SaleOrderEditChange["field"], value: string | number | null) => {
    if (value === null || value === undefined || value === "") return "—";
    if (field === "status") return ({ COMPLETED: "Hoàn thành", IMPORTING_AND_EXPORTING: "Nhập kho / Xuất kho" } as Record<string, string>)[String(value)] || String(value);
    if (field === "quantity") return String(value);
    const date = dayjs(String(value));
    return date.isValid() ? date.format("DD/MM/YYYY") : "—";
};

export const historyRows = (events: SaleOrderEditEvent[] = []): OrderChangeRow[] => events.flatMap(event =>
    event.changes.map((change, index) => ({
        ...change, id: `${event.id}:${index}`, changed_at: event.changed_at,
        editor: event.changed_by?.display_name || "Không rõ người sửa", reason: event.reason,
    })),
);

/** Use the immutable saved order, not the locally edited query data. */
export const previewOrderChanges = (payload: any, original: any, draft: any): OrderChangeRow[] => {
    const rows: OrderChangeRow[] = [];
    const items = original?.items || [];
    const identity = (item: any) => ({
        item_code: item?.product?.product_code || item?.material?.material_code,
        item_name: item?.product?.name || item?.material?.name,
    });

    if (payload.header?.due_date && payload.header.due_date !== original?.due_date) {
        rows.push({ id: "due_date", field: "due_date", old_value: original.due_date, new_value: payload.header.due_date });
    }

    for (const update of payload.update_items || []) {
        const saved = items.find((item: any) => item.id === update.id);
        if (saved && update.quantity !== undefined && Number(update.quantity) !== Number(saved.quantity)) {
            rows.push({ id: update.id, field: "quantity", old_value: Number(saved.quantity),
                new_value: Number(update.quantity), ...identity(saved) });
        }
    }

    for (const id of payload.delete_item_ids || []) {
        const saved = items.find((item: any) => item.id === id);
        if (saved) rows.push({ id, field: "quantity", old_value: Number(saved.quantity), new_value: null, ...identity(saved) });
    }
    
    const draftItems = [...(draft.products || []), ...(draft.materials || [])];
    (payload.add_items || []).forEach((added: any, index: number) => {
        const item = draftItems.find((candidate: any) => !candidate.line_item_id &&
            candidate.id === (added.product_id || added.material_id));
        rows.push({ id: `added:${index}`, field: "quantity", old_value: null, new_value: Number(added.quantity),
            item_code: item?.product_code || item?.material_code, item_name: item?.name });
    });
    return rows;
};
